<template>
  <div
    class="confirm_dialog__modal-mask"
    v-if="isActive"
    @click="onClickOverlay"
  >
    <div class="confirm_dialog__modal_content_container">
      <div class="confirm_dialog__modal_content_wrapper">
        <nav class="confirm_dialog__navigation" v-if="titleText">
          <p class="confirm_dialog__title">{{ titleText }}</p>
        </nav>
        <section
          class="confirm_dialog__dialog_set"
        >
          <div v-if="messageText">
            <p class="confirm_dialog__message">
              {{ messageText }}
            </p>
          </div>

          <div class="confirm_dialog__buttons">
            <ButtonSubmit
              class="confirm_dialog__cancel_button"
              @click.native="onClickCancel"
              :title="cancelButtonText"
            />
            <ButtonSubmit
              class="confirm_dialog__ok_button"
              @click.native="onClickOK"
              :title="okButtonText"
            />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ButtonSubmit from '@/components/ButtonSubmit.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ButtonSubmit,
  }
})
export default class ConfirmDialog extends Vue {
  @Prop({ type: Boolean })
  isActive?: boolean

  @Prop({ type: String })
  titleText?: string

  @Prop({ type: String })
  messageText?: string

  @Prop({ type: String })
  okButtonText?: string

  @Prop({ type: String })
  cancelButtonText?: string

  onClickOK(): void {
    this.finish(true)
  }

  onClickCancel(): void {
    this.finish(false)
  }

  onClickOverlay(): void {
    this.finish(false)
  }

  @Emit('finish')
  finish(ok: boolean): { ok: boolean } {
    return { ok: ok }
  }
}
</script>

<style scoped>
.confirm_dialog__modal-mask {
  position: fixed;
  overflow: hidden;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(38, 38, 38, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm_dialog__modal_content_container {
  width: 300px;
  background: #ffffff;
  overflow: hidden;
  border-radius: 8px;
  z-index: 1;
}

/*
.confirm_dialog__modal_content_wrapper {
  display: grid;
  grid-template-rows: 70px 1fr 44px;
}
*/

.confirm_dialog__navigation {
  width: 100%;
  height: 70px;
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  /*border-bottom: #e8e8e8 1px solid;*/
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  top: 0;
  z-index: 1;
}

.confirm_dialog__title {
  font-family: sans-serif;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #262626;
  padding-left: 16px;
  padding-right: 16px;
}

.confirm_dialog__message {
  font-family: sans-serif;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  margin-right: 16px;
  margin-left: 16px;
  color: #262626;
  padding-bottom: 12px;
}

.confirm_dialog__message {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  margin-right: 16px;
  margin-left: 16px;
  color: #262626;
}

.confirm_dialog__dialog_set {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.confirm_dialog__buttons {
  display: flex;
  justify-content: space-around;
  border-top: #e8e8e8 1px solid;
}

.confirm_dialog__ok_button {
  width: 150px;
  height: 44px;
  background-color: #ffffff;
  color: #007AFF;
  bottom: 0;
  right: 0;
  border-left: #e8e8e8 1px solid;
}

.confirm_dialog__cancel_button {
  width: 150px;
  height: 44px;
  background-color: #ffffff;
  color: #007AFF;
  bottom: 0;
  left: 0;
}
</style>
